import { createAction, handleActions } from 'redux-actions';

const SET_TTS = 'tts/SET_TTS';
/* ?? */
export const TTSList = createAction(SET_TTS);

const initialState = {
  textList:''
};

const tts = handleActions(
  {
    [SET_TTS]: (state, { payload: textList }) => textList,
  },
  initialState
);

export default tts;
